import {gql} from '@apollo/client'

export const CREATE_ORDER_SUBTYPE = gql`
  mutation CreateOrderSubtype($name: String!) {
  createOrderSubtype(
    input: {
        pName: $name
    }
  ) {
    orderSubtype {
      id
      name
    }
  }
}
`

export const GET_ALL_ORDER_SUBTYPES = gql`
  query GetAllOrderSubtypes {
    orderSubtypes(
      orderBy: NAME_ASC
    ) {
      nodes {
        id
        name
      }
      totalCount
    }
  }
`